import { StaticTypes } from "../enums/StaticTypes";
import { LicenseType } from "../interfaces/License";
import { ParkingType } from "../interfaces/Parking";
import {
  PolicyHolderType,
  RegularDriverType,
} from "../interfaces/PolicyHolder";
import { ResidentialAddressType } from "../interfaces/ResidentialAddress";
import { Static } from "../interfaces/Static";
import { VehicleDetailsType } from "../interfaces/VehicleDetails";
import { isRoaming } from "./Common";
import {
  getCodeByDescription,
  getDropdownsByID,
  getMonthNumber,
} from "./Statics";

export const createPayload = (
  policyHolder: PolicyHolderType,
  vehicleDetails: VehicleDetailsType,
  residentialAddress: ResidentialAddressType,
  nightParking: ParkingType,
  dayParking: ParkingType,
  regularDriver: RegularDriverType,
  license: LicenseType,
  customerCode: string | undefined,
  statics: Static[]
) => {
  return {
    policyHolder: {
      title: getCodeByDescription(policyHolder.title, statics),
      firstname: policyHolder.name,
      surname: policyHolder.surname,
      dateOfBirth: `${policyHolder.year}-${getMonthNumber(
        policyHolder.month
      )}-${policyHolder.day}`,
      idNumber: policyHolder.idNumber,
      idType: getCodeByDescription(policyHolder.idType, statics),
      gender: getCodeByDescription(policyHolder.gender, statics),
      cellNumber: policyHolder.mobilePhoneNumber,
      employmentStatus: getCodeByDescription(
        policyHolder.employmentStatus,
        statics
      ),
      maritalStatus: getCodeByDescription(policyHolder.maritalStatus, statics),
      email: policyHolder.email,
      residentialAddress: {
        address1: residentialAddress.address1,
        address2: residentialAddress.address2,
        address3: residentialAddress.address3,
        suburb: residentialAddress.suburb,
        postalCode: residentialAddress.postalCode,
      },
    },
    vehicle: {
      year: Number(vehicleDetails.vehicleYear),
      make: vehicleDetails.hasMMCode
        ? null
        : getCodeByDescription(vehicleDetails.make, statics),
      model: vehicleDetails.hasMMCode ? null : vehicleDetails.modelCode,
      mnmCode: vehicleDetails.mmCode,
      paintColor: getCodeByDescription(vehicleDetails.color, statics),
      vehicleStatus: vehicleDetails.vehicleStatus === true ? "N" : "U",
      useType: getCodeByDescription(vehicleDetails.typeOfUse, statics),
      nightParkingAddress: {
        address1: nightParking.address1,
        address2: nightParking.address2,
        address3: nightParking.address3,
        suburb: nightParking.suburb,
        postalCode: isRoaming(nightParking.parkingLocation)
          ? null
          : Number(nightParking.postalCode),
        parkingMethod: isRoaming(nightParking.parkingLocation)
          ? "10"
          : getCodeByDescription(nightParking.parkingMethod, statics),
        parkingLocation: getCodeByDescription(
          nightParking.parkingLocation,
          getDropdownsByID(StaticTypes.VEHICLE_PARKING_LOCATIONS, statics)
        ),
      },
      dayParkingAddress: {
        address1: dayParking.address1,
        address2: dayParking.address2,
        address3: dayParking.address3,
        suburb: dayParking.suburb,
        postalCode: isRoaming(dayParking.parkingLocation)
          ? null
          : Number(dayParking.postalCode),
        parkingMethod: isRoaming(dayParking.parkingLocation)
          ? "10"
          : getCodeByDescription(dayParking.parkingMethod, statics),
        parkingLocation: getCodeByDescription(
          dayParking.parkingLocation,
          getDropdownsByID(StaticTypes.VEHICLE_PARKING_LOCATIONS, statics)
        ),
      },
    },
    regularDriver: {
      regularDriverThePolicyHolder: regularDriver.policyHolderIsDriver,
      relationshipToPolicyHolder: getCodeByDescription(
        regularDriver.relationshipToPolicyHolder,
        statics
      ),
      licence: {
        firstIssueDate: `${license.year}-${getMonthNumber(license.month)}-${
          license.day
        }`,
        licenceType: getCodeByDescription(license.licenseType, statics),
        licenceCode: getCodeByDescription(license.licenseCode, statics),
        haveCurrentInsurance: license.haveCurrentInsurance,
        ncb: license.haveCurrentInsurance
          ? getCodeByDescription(
              license.coverClaimFreeYears,
              getDropdownsByID(StaticTypes.COVER_CLAIM_FREE_YEARS, statics)
            )
          : "",
        accidentTheftClaimFreeYears: license.haveCurrentInsurance
          ? getCodeByDescription(
              license.theftClaimFreeYears,
              getDropdownsByID(StaticTypes.ACCIDENT_CLAIM_FREE_YEARS, statics)
            )
          : "",
      },
      person: {
        title: getCodeByDescription(regularDriver.title, statics),
        firstname: regularDriver.name,
        surname: regularDriver.surname,
        dateOfBirth: `${regularDriver.year}-${getMonthNumber(
          regularDriver.month
        )}-${regularDriver.day}`,
        idNumber: regularDriver.idNumber,
        idType: getCodeByDescription(regularDriver.idType, statics),
        gender: getCodeByDescription(regularDriver.gender, statics),
        cellNumber: regularDriver.mobilePhoneNumber,
        employmentStatus: getCodeByDescription(
          regularDriver.employmentStatus,
          statics
        ),
        maritalStatus: getCodeByDescription(
          regularDriver.maritalStatus,
          statics
        ),
        email: regularDriver.email,
      },
    },
    consentForITC: true,
    quickQuote: false,
    brokerCode: customerCode,
  };
};
